module.exports = "<div><pre ng-style={color:$ctrl.data.color}>{{$ctrl.data | json}}</pre><button ng-click=$ctrl.closeModal()>Close</button></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/test-modal/test-modal.component.html
// module id = 539
// module chunks = 31